import { PayloadAction } from '@reduxjs/toolkit';
import { SpreadsheetSlice } from './types';

export const saveSheetReducer = (
  state: SpreadsheetSlice,
  action: PayloadAction<{ spreadsheet: string; value: any }>
) => {
  const { spreadsheet, value } = action.payload;
  return {
    ...state,
    [spreadsheet]: value
  };
};
